import { useEffect, useRef, useState } from "react";
import { Activity, Globe2, MapPin, Building2 } from "lucide-react";

function useCountUp(target, active) {
  const [v, setV] = useState(0);
  useEffect(() => {
    if (!active || !target) return;
    let raf, t0;
    const step = (ts) => {
      if (!t0) t0 = ts;
      const p = Math.min(1, (ts - t0) / 1100);
      setV(Math.round(target * (1 - Math.pow(1 - p, 3))));
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [target, active]);
  return v;
}

function Stat({ icon: Icon, value, label, testid }) {
  return (
    <div className="flex items-center gap-3" data-testid={testid}>
      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-primary/10 text-primary"><Icon className="h-4 w-4" /></span>
      <div>
        <div className="font-mono text-xl font-800 leading-none tabular-nums">{value.toLocaleString()}</div>
        <div className="mt-1 text-[11px] font-600 uppercase tracking-wide text-muted-foreground">{label}</div>
      </div>
    </div>
  );
}

export function HeroStats({ data, t }) {
  const ref = useRef(null);
  const [seen, setSeen] = useState(false);
  useEffect(() => {
    if (!ref.current || seen) return;
    const io = new IntersectionObserver((e) => { if (e[0].isIntersecting) { setSeen(true); io.disconnect(); } }, { threshold: 0.2 });
    io.observe(ref.current);
    return () => io.disconnect();
  }, [seen, data]);
  const tests = useCountUp(data?.tests || 0, seen);
  const countries = useCountUp(data?.countries || 0, seen);
  const cities = useCountUp(data?.cities || 0, seen);
  const isps = useCountUp(data?.isps || 0, seen);
  if (!data) return null;
  return (
    <div ref={ref} className="mt-8 grid grid-cols-2 gap-5 rounded-2xl border border-border bg-card/70 p-4 backdrop-blur sm:grid-cols-4" data-testid="hero-stats">
      <Stat icon={Activity} value={tests} label={t("disc.statTests")} testid="hero-stat-tests" />
      <Stat icon={Globe2} value={countries} label={t("disc.statCountries")} testid="hero-stat-countries" />
      <Stat icon={MapPin} value={cities} label={t("disc.statCities")} testid="hero-stat-cities" />
      <Stat icon={Building2} value={isps} label={t("disc.statIsps")} testid="hero-stat-isps" />
    </div>
  );
}
